import React from "react";

import Box from "@mui/material/Box";
import { CssBaseline } from "@mui/material";

import CreateEpisode from "../modules/CreateEpisode";

export default function CreateEpisodePage() {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <CssBaseline />
      <CreateEpisode />
    </Box>
  );
}
